import { useEffect } from 'react';

const HostStatus = () => {
  useEffect(() => {
    const ws = new WebSocket('wss://video-embed-backend.onrender.com');
    return () => ws.close();
  }, []);

  return null;
};

export default HostStatus; 